import React from 'react'
import Link from 'next/link'
import { Trans, useTranslation } from 'next-i18next'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/free-regular-svg-icons'
import { faMicrophone, faPlus, faVideo } from '@fortawesome/free-solid-svg-icons'
import { TrophyDetailComponentDto } from '~/modules/Trophies/Infrastructure/TrophyDetailComponentDto'
import styles from './TrophyMemoriesEmptyState.module.scss'

interface Props {
  trophy: TrophyDetailComponentDto
  appearance?: 'default' | 'market'
}

export const TrophyMemoriesEmptyState: React.FC<Props> = ({ trophy, appearance = 'default' }) => {
  const { t } = useTranslation('trophy_memories')

  return (
    <div>
      <p
        className={ `
          ${styles.trophyMemoryEmptyState__howto}
          ${appearance === 'market' ? styles.trophyMemoryEmptyState__howto__market : ''}
        ` }
      >
        <Trans
          i18nKey={ t('memory_list_description_1') }
          components={ [
            <strong key="strong-desc1-museum"/>,
          ] }
        />
      </p>

      <section
        className={ `
          ${styles.trophyMemoryEmptyState__container}
          ${appearance === 'market' ? styles.trophyMemoryEmptyState__container__market : ''}
        ` }
      >
        <h1
          className={ `
            ${styles.trophyMemoryEmptyState__title}
            ${appearance === 'market' ? styles.trophyMemoryEmptyState__title__market : ''}
          ` }
        >
          { t('empty_state_title') }
        </h1>

        <p
          className={ `
            ${styles.trophyMemoryEmptyState__description}
            ${appearance === 'market' ? styles.trophyMemoryEmptyState__description__market : ''}
          ` }
        >
          <span>
            { t('empty_state_description') }
          </span>
          <br/>
          <span className={ styles.trophyMemoryEmptyState__highlightedDescription }>
            { t('empty_state_highlighted_description') }
          </span>
        </p>

        <Link
          href={ `/trophies/${trophy.id}/memories` }
          className={ `
            ${styles.trophyMemoryEmptyState__addButton}
            ${appearance === 'market' ? styles.trophyMemoryEmptyState__addButton__market : ''}
          ` }
          passHref
        >
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__addIcon }
            icon={ faPlus }
          />
          { t('empty_state_add_button') }
        </Link>

        <div className={ appearance === 'market' ? styles.trophyMemoryEmptyState__multimedia__market : '' }>
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__multimediaIcon }
            icon={ faVideo }
          />
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__multimediaIcon }
            icon={ faImage }
          />
          <FontAwesomeIcon
            className={ styles.trophyMemoryEmptyState__multimediaIcon }
            icon={ faMicrophone }
          />
        </div>
      </section>
    </div>
  )
}
